import { LoginRoutingModule } from './login-routing';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';

@NgModule({
  imports: [
    CommonModule, LoginRoutingModule
  ],
  declarations: [LoginComponent]
})
export class LoginModule { }



// WEBPACK FOOTER //
// /ng-app/src/app/login/login.module.ts